import AppointmentPhaseFilter from "components/filters/Filters/AppointmentPhaseFilter";
import ArtistFilter from "components/filters/Filters/ArtistFilter";
import PeriodFilter from "components/filters/Filters/PeriodFilter";
import ProductionFilter from "components/filters/Filters/ProductionFilter";
import React from "react";

const Filters = () => {
  return <>
    <ArtistFilter />
    <ProductionFilter />
    <AppointmentPhaseFilter />
    <PeriodFilter />
  </>;
};

export default Filters;